import { css } from '@emotion/core';
// import { typography, fontWeights } from '../../../../../styles/typography';
// import { colorsPalette } from '../../../../../styles/colors';
// import { MediaQueries } from '../../../../../styles/Grid';
// import { errorCss } from '../../../../ui/Form/baseStyles/index.styles';

export const iconChevronHolder = css({
  position: 'absolute',
  top: 20,
  right: 16,
  i: {
    transform: 'scale(0.6)',
  },
});
export const overlay = css({
  position: 'fixed',
  background: '#ffffffa8',
  height: '100%',
  width: '100%',
  top: 0,
  zIndex: '1',
  left: 0,
});

export const dateform = css({
  '.rdtPicker td.rdtToday:before': { borderBottom: 'transparent' },
  '.rdtPicker': {
    background: '#fff',
    border: '#D9DBDD solid 1px',
    position: 'absolute',
    top: '-227px',
    width: '100%',
    padding: '24px',
    maxWidth: '368px',
    borderRadius: '8px',

    '.controls': {
      button: {
        background: '#E52500',
        width: '100%',
        borderRadius: '8px',
        color: '#fff',
        height: '56px',
        textTransform: 'uppercase',
        marginTop: '24px',
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: '0.875px',
        textAlign: 'center',
      },
    },
    '.rdtDay:hover': {
      background: 'transparent',
    },

    '.rdtDay span:hover': {
      background: '#EEF0F2',
      borderRadius: '50%',
      color: '#393939',
      width: '32px',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '.past-date': {
      span: {
        background: '#EEF0F2',
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    '.dow': {
      borderBottom: 'none',
      cursor: 'default',
      color: '#747475',
      fontWeight: 400,
      lineHeight: '14px',
      fontSize: '12px',
      paddingTop: '25px',
    },

    td: {
      height: '48px !important',
      verticalAlign: 'middle',
    },

    'td.rdtActive:hover': {
      background: 'transparent',
      color: '#393939',
      span: {
        borderRadius: '50%',
        background: '#008385',
        width: '32px',
        height: '32px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    'td.rdtActive': {
      background: 'transparent',
      color: '#393939',
      span: {
        borderRadius: '50%',
        background: '#008385',
        width: '32px',
        height: '32px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    'th.rdtPrev': {
      fontSize: '21px',
      verticalAlign: 'middle',
      border: '#D9DBDD solid 1px',
      span: {
        width: '100%',
      },
    },

    'th.rdtNext': {
      fontSize: '21px',
      verticalAlign: 'middle',
      border: '#D9DBDD solid 1px',
      background:
        'url(http://regus.dev.local/-/media/regus/redesign/calendar_arrow.png)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',

      span: {
        visibility: 'hidden',
      },
    },

    'th.rdtPrev': {
      fontSize: '21px',
      verticalAlign: 'middle',
      border: '#D9DBDD solid 1px',
      background:
        'url(http://regus.dev.local/-/media/regus/redesign/calendar_arrow.png)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      transform: 'rotate(180deg)',

      span: {
        visibility: 'hidden',
      },
    },

    'th.rdtSwitch': {
      width: '100px',
      verticalAlign: 'middle',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
    },

    th: {
      height: '48px',
      span: {
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    td: {
      span: {
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
});
